<template lang="pug">
.article-dialog
  el-dialog(
    :title='article.title',
    :visible.sync='dialogVisible',
    :fullscreen='!isPc'
    width='900px')
    .dialog-body(v-html='article.contents')

</template>
<script>
import { getArticleDetail } from '@/api'
import { isPC } from '@/utils'
export default {
  name: 'articleDialog',
  data() {
    return {
      isPc: isPC(),
      article: {},
      dialogVisible: false,
    }
  },
  mounted() {
    this.$vgo.on('OPEN_ARTICLE', id => {
      this.id = id
      this.dialogVisible = true
      getArticleDetail(id).then(res => {
        console.log(res)
        this.article = res
      })
    })
  },
}
</script>

<style lang="stylus">
.article-dialog
  max-height 100%
  overflow hidden
  .el-dialog__body
    overflow-y auto
    height 600px
  .el-dialog__header
    box-shadow 0 1px 10px rgba(0, 0, 0, 0.1)
  img
    max-width 100%

@media only screen and (max-width: 2000px)
  .article-dialog
    .el-dialog__header
      color #000
@media only screen and (max-width: 1200px)
  .article-dialog
    .el-dialog__body
      padding 10px
      height calc(100% - 60px)
      box-sizing border-box

::-webkit-scrollbar
  width: 5px
  height: 5px

::-webkit-scrollbar-track
  border-radius: 5px

::-webkit-scrollbar-thumb
  background-color: rgba(0,0,0,.15)
  border-radius: 5px
  -webkit-box-shadow: inset 1px 1px 10px rgba(0,0,0,.15)
</style>
